import {
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableCellProps,
  TableContainer as MuiTableContainer,
  TableContainerProps,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
  TableRowProps,
} from '@mui/material';

export const TableContainer = ({ sx, ...rest }: TableContainerProps) => (
  <MuiTableContainer
    sx={{
      overflowY: 'auto',
      msOverflowStyle: 'initial',
      scrollbarWidth: 'initial',
      '&::-webkit-scrollbar': {
        display: 'block',
        width: 5,
        height: 8,
        backgroundColor: 'grey50',
        borderRadius: 5,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'grey100',
        borderRadius: 5,
      },
      ...sx,
    }}
    {...rest}
  />
);

export const TableRow = ({ sx, ...rest }: TableRowProps) => (
  <MuiTableRow
    sx={{
      '&:last-child td': {
        border: 0,
      },
      ...sx,
    }}
    {...rest}
  />
);

export const TableCell = ({ sx, ...rest }: TableCellProps) => (
  <MuiTableCell sx={{ pl: 0, ...sx }} {...rest} />
);

export const Table = MuiTable;
export const TableBody = MuiTableBody;
export const TableHead = MuiTableHead;
